// extracted by mini-css-extract-plugin
export default {"root":"KPITypeSelect_root__Av7mc","dropdown":"KPITypeSelect_dropdown__6-xrD"};